module.exports = __webpack_public_path__ + "static/media/Portrait-10044.eb139e24.jpg";